export const METADATA_LABELS = {
  reportName: 'Report',
  header: 'Metadata',
  filtersApplied: 'Filters applied',
  description: 'Description',
  relatedGoals: 'Related goals',
  emptyGoalsText: 'No goals available.',
} as const;
